export const quantity = ()=> {
    const quantityUp = document.querySelector('.contact__field-quantity-up')
    const quantityDown = document.querySelector('.contact__field-quantity-down')
    const quantityInput = document.querySelector('input[type=number].contact__field')

    quantityUp?.addEventListener('click',()=> {
        console.log(quantityInput.value)
        if (quantityInput.value === 0 || quantityInput.value === '') {
            quantityInput.value = 1
        } else {
            quantityInput.value = parseInt(quantityInput.value) + 1
        }
    })

    quantityDown?.addEventListener('click',()=> {
        if (quantityInput.value <= 0) {
            quantityInput.value = 0
        } else {
            quantityInput.value = parseInt(quantityInput.value) - 1
        }
    })
}